import React from 'react'
import { Button, createStyles, withStyles } from '@material-ui/core'

import Item from '../../../Item'

const styles = () => {
  return createStyles({
    button: {
      padding: 0,
    },
  })
}

const Toggle = ({ handleClick, menuId, classes }) => {
  return (
    <Item>
      <Button
        onClick={handleClick}
        aria-controls={menuId}
        aria-haspopup
        className={classes.button}
      >
        Programmes
      </Button>
    </Item>
  )
}

export default withStyles(styles)(Toggle)
